import Text from '../Typography/Text';
import styled from 'styled-components';

export const Controls = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  margin-top: 40px;
`;

export const ControlButton = styled.button`
  cursor: ${props => (props.disabled ? 'auto' : 'pointer')};
  width: 32px;
  height: 32px;
  border-radius: 50%;
  border: 1px solid #d9dcde;
  background-color: transparent;
  padding: 8px;
  min-width: auto;

  opacity: ${props => props.disabled && '0.5'};

  ${props =>
    props.active &&
    `
    &:hover {
      border: 1px solid #808b91;
    }
  `};
`;

export const DotWrapper = styled.div`
  width: ${props => (props.active ? 42 : 12)}px;
  height: 2px;

  background-color: ${props => (props.active ? '#fd6f48' : '#d9dcde')};
`;

export const Dot = styled.div``;

export const SliderPagination = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;

  .swiper-bullet {
    display: block;
    height: 2px;
    width: 12px;
    margin-right: 7px;
    background-color: #d9dcde;
    transition: all 0.3s ease;
  }

  .swiper-bullet-active {
    width: 42px;
    background-color: #fd6f48;
  }
`;

export const Caption = styled.div`
  border-left: 2px solid #05425e;
  padding-left: 20px;
  margin-top: 20px;
`;
